module.exports = __webpack_public_path__ + "static/img/oil6.5287310f.png";